import styled from 'styled-components'
import { BaseButtonProps } from './ButtonOverlay'
import { borderRadius } from '../../../styles/variables'
import { anchorReset } from '../../../styles/fragments'
import { iPadDown } from '../../../styles/mediaQueries'
import theme from './theme'
import { ButtonSizes } from '../types'

interface ButtonWrapperProps extends BaseButtonProps {
  fullWidth: boolean
  size: ButtonSizes
}

const ButtonWrapper = styled.span<ButtonWrapperProps>`
  display: inline-block;
  position: relative;
  ${borderRadius};
  ${({ dolaTheme, variant = 'primary' }) => `
      background: ${theme[dolaTheme][variant].border};
      color: ${theme[dolaTheme][variant].text};
  `}
  ${({ size }) =>
    size === 'small'
      ? `
    line-height: .9;
  `
      : ''}
  ${({ fullWidth }) =>
    fullWidth
      ? `
    flex-grow: 1;
    width: 100%;
  `
      : ''}

  a {
    ${anchorReset}
  }

  &:hover {
    button {
      transform: translate(0.3vw, -0.3vw);

      ${iPadDown} {
        transform: translate(0.93vw, -0.93vw);
      }
    }
  }
`

export default ButtonWrapper
